













































































































































































































































































































































































































import {
  faPlus,
  faSearch,
  faShareAlt,
  faTimes
} from '@fortawesome/free-solid-svg-icons'
import QnaModalForm from '~/components/car/qna/QnaModalForm.vue'
import QnaForm from '~/components/car/qna/QnaForm.vue'
import QnaQuestionHeader from '~/components/car/qna/QnaQuestionHeader.vue'
import QnaTags from '~/components/car/qna/QnaTags.vue'
import { toCamelCase, removeKeysWithNoValues } from '~/utils/object'
import {
  toSnakeCase,
  arrayOfStringToSnakeCase,
  camelToUnderscore
} from '~/utils/snake-case'
import {
  QnaQuestion,
  SelectedParam as SelectedParamType,
  QnaTabs
} from '~/models/qna/types'
import ClearAllButton from '~/components/car/classifieds/search/facets/ClearAllButton.vue'
import QnaCommentsWrapper from '~/components/car/qna/QnaCommentsWrapper.vue'
import CCategoryIcon from '~/components/shared/configurable/category/CCategoryIcon.vue'
import { Make, Model } from '~/models/make-model'
import CSelectedFilters from '~/components/shared/configurable/CSelectedFilters.vue'
import { mapGetters, mapState, mapActions, mapMutations } from 'vuex'
import { USER_NS } from '~/store/modules/shared/user/state'
import CMobileSidebar from '~/components/shared/configurable/CMobileSidebar.vue'
import CFacetsFloatingButton from '~/components/shared/configurable/button/CFacetsFloatingButton.vue'
import { capitalizeSentences } from '~/utils/string'
import NoResultsFound from '~/components/car/classifieds/search/results/rows/NoResultsFound.vue'
import CFloatingButton from '~/components/shared/configurable/CFloatingButton.vue'
import { mapDeps } from '~/plugins/dependency-container/utils'
import QnaService from '~/services/qna/QnaService'
import MakeModelService from '~/services/MakeModelService'
import { PAGE_NS } from '~/store/modules/shared/page/state'
import { Corner, FloatingCornerElementName } from '~/models/layout'
import { QNA_NS } from '~/store/modules/shared/qna/state'
import CShareButtons from '~/components/shared/configurable/social/CShareButtons.vue'
import { USER_AGENT_NS } from '~/store/modules/shared/userAgent/state'
import HeadService from '~/services/HeadService'
import CFacetButton from '~/components/shared/configurable/button/CFacetButton.vue'
import QnaPayAttention from '~/components/car/qna/QnaPayAttention.vue'
import QnaLeaderboard from '~/components/car/qna/QnaLeaderboard.vue'
import { ciLeaderboard } from '~/icons/source/solid/leaderboard'
import CTab from '~/components/shared/configurable/tab/CTab.vue'
import CTabs from '~/components/shared/configurable/tab/CTabs.vue'
import CPagination from '~/components/shared/configurable/pagination/CPagination.vue'
import { defineComponent } from '@nuxtjs/composition-api'
import CAnonGuardModal from '~/components/shared/configurable/user/CAnonGuardModal.vue'
import { REMOVE_CORNER_ELEMENT } from '~/store/modules/shared/page/mutation-types'
import { defineVue3AsyncComponent, vue3Set } from '~/utils/nuxt3-migration'

export default defineComponent({
  components: {
    CAnonGuardModal,
    CPagination,
    QnaForm,
    QnaModalForm,
    CTab,
    CTabs,
    QnaCommentsWrapper,
    QnaQuestionHeader,
    ClearAllButton,
    CCategoryIcon,
    CSelectedFilters,
    CMobileSidebar,
    CFacetsFloatingButton,
    NoResultsFound,
    CFloatingButton,
    QnaTags,
    CFacetButton,
    QnaPayAttention,
    CShareModal: defineVue3AsyncComponent(() =>
      import('~/components/shared/configurable/social/CShareModal.vue')
    ),
    CShareButtons,
    QnaLeaderboard
  },

  async asyncData({ $dep, route, store }) {
    const { make: makeIds, q, t, pg } = route.query

    const qnaService = $dep(QnaService)

    const userId = store.getters[`${USER_NS}/userId`]
    const isAnon = store.getters[`${USER_NS}/isAnon`]

    const category = parseInt(route.query.category as string, 10) || null
    const requests = []
    let activeTab = QnaTabs.LATEST

    if (t === QnaTabs.MY && userId && !isAnon) {
      activeTab = QnaTabs.MY
      requests.push(
        store.dispatch(`${QNA_NS}/qnaSearch`, { ...route.query, userId })
      )
    } else if (t === QnaTabs.MY && isAnon) {
      delete route.query.t

      requests.push(store.dispatch(`${QNA_NS}/qnaSearch`, route.query))
    } else {
      requests.push(store.dispatch(`${QNA_NS}/qnaSearch`, route.query))
    }

    if (qnaService.isVehicle(category)) {
      requests.push(
        store.dispatch(`${QNA_NS}/fetchMakesByCategoryId`),
        category
      )
    }

    if (makeIds && makeIds.length) {
      requests.push(
        store.dispatch(`${QNA_NS}/fetchModelsByMake`, {
          categoryId: category,
          makeIds
        })
      )
    }

    await Promise.all([
      ...requests,
      store.dispatch(`${QNA_NS}/fetchAllCategories`)
    ])

    return {
      searchText: q || '',
      currentPage: parseInt(pg, 10) || 1,
      selectedCategoryId: category,
      activeTab
    }
  },
  data() {
    return {
      questionForEdit: null,
      query: '',
      isQnaModalFormVisible: this.$router.currentRoute.hash === '#create',
      fuelTypesByCategory: null,
      tagsByCategory: null,
      selectedTags: [],
      categoryName: null,
      isSidebarVisible: false,
      numOfFilters: null,
      isFloatingButtonsVisible: false,
      queryParams: {},
      searchText: '',
      currentPage: 1,
      activeTab: QnaTabs.LATEST,
      selectedCategoryId: null,
      shareModalVisible: false,
      isLoginAlertVisible: false,
      isFloatingAskQuestionButtonVisible: true,
      isFloatingButtonMounted: false,
      isLeaderboardVisible: false,
      isAnonGuardModalVisible: false
    }
  },
  computed: {
    ...mapGetters(USER_NS, {
      isAnon: 'isAnon'
    }),
    ...mapState(QNA_NS, {
      questions: state => state.questions,
      pagination: state => state.pagination,
      dropdownCategories: state => state.dropdownCategories,
      categories: state => state.categories,
      fuelTypes: state => state.fuelTypes,
      tags: state => state.tags,
      loading: state => state.loading,
      makeAndModelsByCategory: state => state.makeAndModelsByCategory
    }),
    ...mapState(USER_NS, {
      userId: state => state.id,
      permissions: state => state.permissions
    }),
    ...mapGetters(USER_AGENT_NS, {
      isMobile: 'isMobile'
    }),
    ...mapDeps({
      qnaService: QnaService,
      makeModelService: MakeModelService
    }),
    isAnyLoaderActive(): boolean {
      return this.loading.questions || this.loading.makesAndModels
    },
    categoryTags(): Array<{ name: string; id: number }> {
      if (this.selectedCategoryId && Object.keys(this.tags).length) {
        return this.tags[this.selectedCategoryId]
      }
      return null
    },
    categoryFuelTypes(): object {
      return this.fuelTypes[this.selectedCategoryId]
    },
    numberOfPages(): number {
      if (this.pagination?.total) {
        return Math.ceil(this.pagination.total / this.pagination.perPage)
      }

      return 0
    },
    makes(): [] {
      if (
        this.selectedCategoryId &&
        this.makeAndModelsByCategory[this.selectedCategoryId] &&
        this.makeAndModelsByCategory[this.selectedCategoryId]?.makes
      ) {
        return this.makeAndModelsByCategory[this.selectedCategoryId].makes
      }
      return []
    },
    topMakes(): [] {
      if (
        this.selectedCategoryId &&
        this.makeAndModelsByCategory[this.selectedCategoryId]
      ) {
        return this.makeAndModelsByCategory[this.selectedCategoryId].topMakes
      }
      return []
    },
    makesWithModels() {
      return this.makes.filter(m => m?.models)
    },

    headerTitle(): string {
      const { make, model } = this.queryParams
      const normalizedMakes = make ? [make].flat() : []
      const normalizedModels = model ? [model].flat() : []
      if (normalizedMakes.length === 1) {
        const mk: Make = this.makes.find((m: Make) =>
          normalizedMakes.includes(m.id.toString())
        )

        if (mk?.models && normalizedModels.length === 1) {
          const md: Model | undefined = mk.models.find((m: Model) =>
            normalizedModels.includes(m.value.toString())
          )
          if (md) {
            return `${mk?.name} ${md.text}`
          }

          return mk.name
        }
        return mk?.name
      }
      return this.categoryName
    },
    latestUrl(): string {
      return this.$router.resolve({
        query: { ...this.$route.query, t: QnaTabs.LATEST, pg: 1 }
      }).href
    },
    myUrl(): string {
      return this.$router.resolve({
        query: { ...this.$route.query, t: QnaTabs.MY, pg: 1 }
      }).href
    },
    selectedFilters(): SelectedParamType[] {
      const {
        category,
        make,
        tag,
        fuelType,
        model,
        fromYear,
        toYear,
        q,
        deleted
      } = toCamelCase(this.queryParams)
      let makes = []
      let selectedParams = []
      if (category && this.dropdownCategories?.length) {
        const categoryLabel = this.dropdownCategories.find(
          dc => dc.id.toString() === category
        )?.label
        selectedParams.push({
          id: parseInt(category, 10),
          label: categoryLabel,
          queryName: 'category'
        })
      }
      if (
        category &&
        make &&
        make.length &&
        this.makeAndModelsByCategory[category]
      ) {
        makes = this.getMakesLabelAndId(make, this.makes)
        selectedParams = selectedParams.concat(makes)
      }
      if (category && this.tags && tag?.length && this.categoryTags) {
        let tags = this.categoryTags.filter(t => tag.includes(t.id.toString()))
        tags = tags.map(t => ({ id: t.id, label: t.name, queryName: 'tag' }))
        selectedParams = selectedParams.concat(tags)
      }
      if (fuelType?.length && this.categoryFuelTypes) {
        let fuelTypes = this.categoryFuelTypes.filter(
          cf => cf.id.toString() === fuelType
        )
        fuelTypes = fuelTypes.map(f => ({
          id: f.id,
          label: f.name,
          queryName: 'fuelType'
        }))
        // fuelType
        selectedParams = selectedParams.concat(fuelTypes)
      }
      if (model?.length && makes.length) {
        const modelsArray = [model].flat()
        const selectedModel = []
        this.makes.forEach(m => {
          if (m?.models) {
            m.models.forEach(md => {
              if (
                modelsArray.includes(`${md.value}`) &&
                !selectedModel.some(s => s.id === md.value)
              ) {
                selectedModel.push({
                  id: md.value,
                  label: md.text,
                  queryName: 'model'
                })
              }
            })
          }
        })
        selectedParams = selectedParams.concat(selectedModel)
      }
      if (fromYear?.length && fromYear[0]) {
        selectedParams.push({
          id: fromYear,
          label: `${this.$i18n.t('from')}: ${fromYear}`,
          queryName: 'fromYear'
        })
      }
      if (toYear?.length && toYear[0]) {
        selectedParams.push({
          id: toYear,
          label: `${this.$i18n.t('to')}: ${toYear}`,
          queryName: 'toYear'
        })
      }
      if (q) {
        selectedParams.push({
          id: null,
          label: q,
          queryName: 'q'
        })
      }
      if (deleted) {
        selectedParams.push({
          id: deleted,
          label: this.$i18n.t('deleted::plural_f'),
          queryName: 'deleted'
        })
      }

      return selectedParams
    },
    resultText() {
      return capitalizeSentences(
        this.$i18n.tc(
          'show 1 question | show {count} questions',
          this.pagination.total
        )
      )
    },
    icons() {
      return {
        plus: faPlus,
        close: faTimes,
        share: faShareAlt,
        search: faSearch,
        leaderboard: ciLeaderboard
      }
    },
    shareTitle() {
      if (this.headerTitle) {
        return `${this.headerTitle} - ${this.$i18n
          .t('questions and answers')
          .toLowerCase()}`
      }
      return this.$i18n.t('questions and answers')
    },
    hasCreateHash() {
      return this.$router.currentRoute.hash === '#create'
    },
    searchParam() {
      const { q } = this.queryParams
      if (q) {
        return [
          {
            id: null,
            label: q,
            queryName: 'q'
          }
        ]
      }
      return null
    }
  },
  watch: {
    '$route.query'(newQuery, oldQuery) {
      this.queryParams = newQuery
      const tab = newQuery.t
      if (tab && !this.isAnon) {
        this.activeTab = tab
      } else {
        this.activeTab = QnaTabs.LATEST
      }
      this.selectedCategoryId = newQuery.category
        ? parseInt(newQuery.category, 10)
        : null
      this.searchText = oldQuery.q ? newQuery.q : this.searchText
      this.currentPage = newQuery.pg || 1
      if (JSON.stringify(newQuery) !== JSON.stringify(oldQuery)) {
        this.setSelectedTags()
        if (tab === QnaTabs.MY && this.userId && !this.isAnon) {
          this.fetchMyQuestions(newQuery)
        } else {
          this.qnaSearch(newQuery)
        }
        this.numOfFilters = this.numberOfFilters(newQuery)
        if (
          this.selectedCategoryId &&
          this.qnaService.isVehicle(this.selectedCategoryId)
        ) {
          this.handleFetchMakesByCategoryId(this.selectedCategoryId)
        }
        if (newQuery.make) {
          this.fetchModelsByMake({
            categoryId: this.selectedCategoryId,
            makeIds: newQuery.make
          })
        }
      }
      if (this.$refs.qnaForm) {
        this.$refs.qnaForm.setFieldValuesFromQueryParams(toCamelCase(newQuery))
      }
      this.scrollToTop()
    },
    dropdownCategories() {
      this.setFormData()
    }
  },
  created() {
    this.queryParams = { ...this.$route.query }
    this.numOfFilters = this.numberOfFilters(this.queryParams)
    this.initValues(this.makes)
  },
  mounted() {
    this.isFloatingButtonsVisible = true
    if (this.hasCreateHash && this.isAnon) {
      this.isLoginAlertVisible = true
    } else if (this.hasCreateHash && !this.isAnon) {
      this.isQnaModalFormVisible = true
    }

    this.addCornerElement({
      name: FloatingCornerElementName.QNA_QUESTION_BUTTON,
      corner: Corner.BOTTOM_RIGHT
    })
  },
  beforeDestroy() {
    this.removeCornerElement({
      name: FloatingCornerElementName.QNA_QUESTION_BUTTON,
      corner: Corner.BOTTOM_RIGHT
    })
  },
  methods: {
    ...mapMutations(PAGE_NS, {
      removeCornerElement: REMOVE_CORNER_ELEMENT
    }),
    ...mapActions(PAGE_NS, ['addCornerElement']),
    ...mapActions(QNA_NS, [
      'qnaSearch',
      'fetchAllCategories',
      'fetchModelsByMake',
      'fetchMakesByCategoryId'
    ]),
    handleTagClick(selectedTag: { name: string; id: number }) {
      if (this.isAnyLoaderActive) {
        return
      }
      if (selectedTag) {
        if (this.selectedTags.find(s => s.id === selectedTag.id)) {
          this.selectedTags = this.selectedTags.filter(
            s => s.id !== selectedTag.id
          )
        } else {
          this.selectedTags.push(selectedTag)
        }
        const tag = this.selectedTags.map(t => t.id)
        this.handleParamChange({ value: tag, field: 'tag' })
      }
    },
    handleClose() {
      this.isQnaModalFormVisible = false
      this.questionForEdit = null
      if (this.$router.currentRoute.hash === '#create') {
        this.$router.push({
          hash: null
        })
      }
    },
    handleDeleteComment(questionId: string) {
      const question = this.questions.find(q => q.id === questionId)
      vue3Set(question, 'questionReplies', question.questionReplies - 1)
    },
    handleCreateQuestion() {
      if (!this.isAnon) {
        this.questionForEdit = null
        this.isQnaModalFormVisible = true
      } else {
        this.isAnonGuardModalVisible = true
      }
    },
    handleSearchCategoryChange({
      categoryId,
      label
    }: {
      categoryId: number
      label: string
    }) {
      this.categoryName = label
      if (this.selectedCategoryId !== categoryId) {
        this.selectedCategoryId = categoryId
        this.setRouterParams({
          ...this.removeQueryParamsFromRouter(null, ['deleted']),
          pg: null,
          category: categoryId
        })
      }
    },
    handleSearchText(data: { field: string; value: string }) {
      if (data.value) {
        this.setParamsWithoutPageParam(data)
      }
    },
    setParamsWithoutPageParam({ field, value }) {
      this.setRouterParams({
        ...this.removeQueryParamsFromRouter(['pg']),
        [field]: value
      })
    },

    getMakesLabelAndId(
      queryMakes: string[],
      makes: Make[]
    ): { id: number; label: string; queryName: string }[] {
      const filteredMakes = makes.filter(m =>
        queryMakes.includes(m.id.toString())
      )
      return filteredMakes.map(f => ({
        id: f.id,
        label: f.name,
        queryName: 'make'
      }))
    },

    handleSelectedClick(params: SelectedParamType) {
      if (this.isAnyLoaderActive) {
        return
      }
      switch (params.queryName) {
        case 'category': {
          this.setRouterParams({
            ...this.removeQueryParamsFromRouter(null, ['deleted']),
            category: null
          })
          break
        }
        case 'q': {
          this.setRouterParams({
            ...this.removeQueryParamsFromRouter(['q'])
          })
          break
        }
        case 'make': {
          const { query } = this.$router.currentRoute
          const queryToUpdate = { ...query }
          queryToUpdate.model = query.model ? [query.model].flat() : []
          queryToUpdate.make = query.make ? [query.make].flat() : []
          let models = [...queryToUpdate.model]
          if (!queryToUpdate.model) {
            queryToUpdate[params.queryName] = [queryToUpdate[params.queryName]]
              .flat()
              .filter(p => p !== params.id.toString())
          } else if (queryToUpdate.make.length) {
            const currentMake = this.makes.find(mk => mk.id === params.id)
            queryToUpdate.model.forEach(md => {
              const modelBelongsToMake = currentMake.models.find(
                mdl => mdl.value.toString() === md
              )
              if (modelBelongsToMake) {
                models = models.filter(
                  model => model !== modelBelongsToMake.value.toString()
                )
              }
            })
          }

          queryToUpdate.model = models
          queryToUpdate.make = queryToUpdate.make.filter(
            m => m !== params.id.toString()
          )
          this.setRouterParams(queryToUpdate)
          break
        }
        default: {
          const { query } = this.$router.currentRoute
          const queryToUpdate = { ...query }
          queryToUpdate[params.queryName] = [queryToUpdate[params.queryName]]
            .flat()
            .filter(p => p !== params.id.toString())
          this.setRouterParams(queryToUpdate)
        }
      }
    },
    handleQuestionDeleted(questionId: string) {
      const qIndex = this.questions.findIndex(q => q.id === questionId)
      vue3Set(this.questions, qIndex, {
        ...this.questions[qIndex],
        isDeleted: true
      })
    },
    numberOfFilters(query: object): number {
      const {
        fromYear,
        fuelType,
        make,
        model,
        toYear,
        category,
        deleted
      } = toCamelCase(query)
      let numOfFilters: number = [
        fromYear,
        fuelType,
        make,
        model,
        toYear,
        category,
        deleted
      ].filter(f => f && f.length).length
      if (fromYear && toYear) {
        numOfFilters--
      }
      return numOfFilters
    },
    handleMakeChange(
      data: { value: number[]; field: string; categoryId?: number },
      onlyFetch: boolean = false
    ) {
      const { makes } = this.makeAndModelsByCategory[this.selectedCategoryId]
      let models = this.$router.currentRoute.query.model || []
      models = [models].flat().map(m => parseInt(m, 10))
      if (!onlyFetch) {
        const { field, value } = data
        const excludedModelIds = []
        let paramToDelete = []
        if (value?.length === 0) {
          paramToDelete = ['model']
        } else {
          const selectedMakesData = makes.filter(m => value.includes(m.id))
          selectedMakesData.forEach(m => {
            if (m.models) {
              m.models.find(md => {
                if (models.includes(md.value)) {
                  excludedModelIds.push(md.value)
                }
              })
            }
          })
        }
        this.setRouterParams({
          ...this.removeQueryParamsFromRouter(paramToDelete),
          model: models.filter(m => excludedModelIds.includes(m)),
          pg: null,
          [field]: value
        })
      }
    },
    isTabActive(tab: QnaTabs): boolean {
      return this.activeTab === tab
    },
    handlePageChange(page: number) {
      const { pg } = this.$router.currentRoute.query
      if (page.toString() !== pg) {
        this.handleParamChange({ value: page, field: 'pg' })
      }
    },
    handleParamChange(
      { value, field },
      setOnRouterQueryParams: boolean = true
    ) {
      const query = {
        ...this.$router.currentRoute.query
      }
      if (!value && field) {
        delete query[camelToUnderscore(field)]
      } else {
        query[field] = value
      }
      if (setOnRouterQueryParams) {
        if (field !== 'pg') {
          this.currentPage = 1
          delete query.pg
        }
        this.setRouterParams(query)
      }
      // this.scrollToTop()
    },

    removeQueryParamsFromRouter(
      paramsToDelete: Array<string> = null,
      excludeParams: Array<string> = []
    ): object {
      const filteredParams = [
        'make',
        'model',
        'tag',
        'fuelType',
        'fromYear',
        'toYear',
        'deleted'
      ].filter(p => !excludeParams.includes(p))
      const delParams = arrayOfStringToSnakeCase(
        paramsToDelete || filteredParams
      )
      const qParams = { ...this.$router.currentRoute.query }
      delParams.forEach(p => {
        delete qParams[p]
      })
      return qParams
    },
    setRouterParams(query: object, queryToUpdate: object = {}) {
      this.$router.push({
        query: removeKeysWithNoValues({
          ...toSnakeCase(query),
          ...queryToUpdate
        })
      })
    },
    handleEditQuestion(question: QnaQuestion) {
      this.questionForEdit = question
      this.$nextTick(() => (this.isQnaModalFormVisible = true))
    },
    isTagSelected(tagId: number): boolean {
      return !!this.selectedTags.find(t => t.id === tagId)
    },
    setSelectedTags() {
      const { query } = this.$router.currentRoute
      if (query?.tag && this.selectedCategoryId && this.tags) {
        const tag = Array.isArray(query.tag) ? query.tag : [query.tag]
        this.selectedTags = tag.map(t => ({
          id: parseInt(t, 10),
          name: this.tags[this.selectedCategoryId][parseInt(t, 10)]
        }))
      } else {
        this.selectedTags = []
      }
    },

    clearFilters() {
      this.$refs.qnaForm.setFieldValuesFromQueryParams({
        fromYear: null,
        fuelType: null,
        make: null,
        model: null,
        tag: null,
        toYear: null,
        category: null
      })
      this.setRouterParams({ t: this.activeTab })
    },

    initValues(makes) {
      if (makes) {
        vue3Set(this.makeAndModelsByCategory, this.selectedCategoryId, makes)
      }
      this.setSelectedTags()
    },

    setFormData() {
      const category = this.dropdownCategories.find(
        dc => dc.id === this.selectedCategoryId
      )
      this.setSelectedTags()

      // Set category
      if (this.$refs?.qnaForm && category) {
        this.categoryName = category.label
        this.$refs.qnaForm.handleDropdownCategoryChange(category)
      }
      // Set models
      if (
        this.makesWithModels?.length === 1 &&
        this.$refs?.qnaForm?.setModels
      ) {
        this.$refs.qnaForm.setModels(this.makesWithModels[0].models)
      } else if (this.makesWithModels?.length > 1 && this.$refs.qnaForm) {
        const normalizedMakesWithModels = this.makesWithModels
          .map(m => ({ label: m.name, options: m.models }))
          .flat()
        this.$refs.qnaForm.setModels(normalizedMakesWithModels)
      }
    },
    updateMakes(makes: Array<Make>, makesWithModels: Array<Make>): Array<Make> {
      return makes.map(m => {
        const make = makesWithModels.find(mm => mm.id === m.id)
        return make || m
      })
    },
    handleQuestionCreated() {
      this.isQnaModalFormVisible = false
    },
    handleKeyDown(event: KeyboardEvent) {
      if (event.key === 'Enter') {
        this.handleSearchText({ field: 'q', value: this.searchText })
      }
    },
    handleQuestionUpdate() {
      this.isQnaModalFormVisible = false
    },
    fetchMyQuestions(query: object) {
      this.qnaSearch({ ...query, userId: this.userId })
    },
    toggleMobileFacets() {
      this.isSidebarVisible = !this.isSidebarVisible
    },
    scrollToTop() {
      window.scrollTo(0, 0)
    },
    handleShowDeleted(data: { field: string; value: string }) {
      this.setParamsWithoutPageParam({ ...data, value: data.value || null })
    },
    handleFloatingButtonVisibilityChange(visible: boolean) {
      this.isFloatingAskQuestionButtonVisible = visible
    },

    async handleFetchMakesByCategoryId(
      categoryId: number,
      setCategoryId: boolean = true
    ) {
      if (setCategoryId) {
        this.selectedCategoryId = categoryId
      }
      await this.fetchMakesByCategoryId(categoryId)

      if (!this.isQnaModalFormVisible && this.$refs.qnaForm) {
        this.$refs.qnaForm.setModels(null)
      }
    }
  },
  head() {
    const headService = this.$dep(HeadService)
    const filtersString = this.selectedFilters.map(f => f.label).join(', ')
    const title = `${this.$i18n.t('questions and answers')} ${
      filtersString.length ? ' - ' + filtersString : ''
    }`
    const threads = this.$i18n.tc(
      '1 thread | {count} threads',
      this.questions.length
    )
    let description = `${this.$i18n.t('see::user_profile')} ${threads} `
    if (!this.questions.length) {
      description = `${this.$i18n.t('see::user_profile')} ${
        threads.split(' ')[1]
      } `
    }
    if (filtersString) {
      description += `${this.$i18n.t('for').toLowerCase()} ${filtersString}`
    }
    return headService.createHead({
      title,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: description
        },
        {
          hid: 'og:description',
          name: 'og:description',
          content: description
        },
        headService.createOgImageMetaItem('/nuxt-static/img/og/car-qna.jpg')
      ]
    })
  }
})
